import isBefore from "date-fns/isBefore";
export var hasFaireDirectMarketplaceIncentive = function(faireDirectMarketplaceIncentive, isLoggedInRetailer) {
    if (!faireDirectMarketplaceIncentive) {
        return false;
    }
    var isRetailerEligible = faireDirectMarketplaceIncentive.is_retailer_eligible, offerName = faireDirectMarketplaceIncentive.offer_name, expiresAt = faireDirectMarketplaceIncentive.expires_at;
    var isFaireDirectEvergreenIncentive = offerName === "EVERGREEN_MARKETPLACE_DISCOUNT";
    // If expiresAt is not defined, default to incentive not being expired.
    var isExpired = expiresAt ? isBefore(expiresAt, Date.now()) : false;
    return !!isRetailerEligible && isLoggedInRetailer && (isFaireDirectEvergreenIncentive ? true : !isExpired);
};
